import { PaletteOptions } from "@mui/material"

// Define custom color types

interface OtherColorTypes {
  divider: string
  border: string
}
declare module "@mui/material/styles/createPalette" {
  interface SimplePaletteColorOptions {
    states?: {
      outlinedRestingBorder?: string
      outlinedHoverBackground?: string
      containedHoverBackground?: string
    }
  }
  interface PaletteColor {
    states?: {
      outlinedRestingBorder?: string
      outlinedHoverBackground?: string
      containedHoverBackground?: string
    }
  }
  interface Palette {
    mute: SimplePaletteColorOptions
    other: OtherColorTypes
  }
  interface PaletteOptions {
    mute: SimplePaletteColorOptions
    other: OtherColorTypes
  }
}

const GREY_TONES = {
  100: "#E4E4E4",
  200: "#A7A7A7",
  300: "#7D7D7D",
  500: "#404040",
  700: "#252525",
}
const lightPalette: PaletteOptions | undefined = {
  mode: "light",
  primary: {
    main: "#007BB2",
    dark: "#007BB2",
    light: "#007BB2",
    states: {
      outlinedRestingBorder: "#007BB2",
      outlinedHoverBackground: "#E6FFFF",
      containedHoverBackground: "#007BB2",
    },
  },
  secondary: {
    main: "#00A68C",
    dark: "#D07647",
    light: "#FAF3CE",
    states: {
      outlinedRestingBorder: "#00A68C",
      outlinedHoverBackground: "#FAF3CE",
      containedHoverBackground: "#D07647",
    },
  },
  mute: {
    main: "#FAF3CE",
    dark: "#E3D899",
    states: {
      containedHoverBackground: "#E3D899",
    },
  },
  info: {
    main: "#4B11F2",
    states: {
      outlinedRestingBorder: "#4B11F2",
      outlinedHoverBackground: "#C9B8FB",
      containedHoverBackground: "#2F099F",
    },
  },
  background: {
    default: "#FAF3CE",
    paper: "#FDFDF8",
  },
  action: {
    hover: "#FAF3CE",
    hoverOpacity: 0.1,
    active: "#FFEA91",
    disabled: "#A7A7A7",
  },
  success: {
    main: "#007BB2",
  },
  warning: {
    main: "#FAEA5D",
    dark: "#817F48",
    light: "#FFEA91",
  },
  error: {
    main: "#FB5A5A",
    dark: "#68282F",
  },
  text: {
    secondary: "#252525",
  },
  divider: "#E3D899",
  grey: GREY_TONES,
  other: {
    divider: "#E3D899",
    border: "#7D7D7D",
  },
}

const darkPalette: PaletteOptions | undefined = {
  mode: "dark",
  primary: {
    main: "#007BB2",
    dark: "#007BB2",
    light: "#83EBEB",
    states: {
      outlinedRestingBorder: "#007BB2",
      outlinedHoverBackground: "#007BB2",
      containedHoverBackground: "#E6FFFF",
    },
  },
  secondary: {
    main: "#00A68C",
    dark: "#D07647",
    light: "#FAF3CE",
    states: {
      outlinedRestingBorder: "#00A68C",
      outlinedHoverBackground: "#D07647",
      containedHoverBackground: "#FAF3CE",
    },
  },
  mute: {
    main: "#311188",
    light: "#4B11F2",
    states: {
      containedHoverBackground: "#4B11F2",
    },
  },
  info: {
    main: "#4B11F2",
    dark: "#2F099F",
    light: "#9B91FF",
    states: {
      outlinedRestingBorder: "#4B11F2",
      outlinedHoverBackground: "#270782",
      containedHoverBackground: "#C9B8FB",
    },
  },

  action: {
    hover: "#311188",
    active: "#4B11F2",
    disabled: "#A7A7A7",
    disabledBackground: "#404040",
    hoverOpacity: 0.5,
    selected: "#4B11F2",
  },
  success: {
    main: "#007BB2",
    dark: "#007BB2",
    light: "#83EBEB",
  },
  error: {
    main: "#FB5A5A",
    dark: "#68282F",
    light: "#FDA49A",
  },
  background: {
    default: "#000",
    paper: "#1A1A1A",
  },
  divider: "#FFF",
  other: {
    divider: "#000",
    border: "#7D7D7D",
  },
  grey: GREY_TONES,
}
export default { lightPalette, darkPalette }
